import { Outlet, NavLink, Link, useLocation } from 'react-router-dom';
import { Home, FolderOpen, Sparkles, MessagesSquare, Settings as SettingsIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SettingsProvider, useClientSettings, accentClasses } from './settings';
import Splash from './Splash';

function ClientPwaShell() {
  const { settings, t } = useClientSettings();
  const location = useLocation();
  const accent = accentClasses[settings.accent];

  const navItems = [
    { to: '/client-pwa', icon: Home, label: t('home'), end: true },
    { to: '/client-pwa/files', icon: FolderOpen, label: t('files') },
    { to: '/client-pwa/insights', icon: Sparkles, label: t('insights') },
    { to: '/client-pwa/help', icon: MessagesSquare, label: t('help') },
  ];

  const onSettingsPage = location.pathname.startsWith('/client-pwa/settings');

  return (
    <div
      className={cn(
        'min-h-screen bg-background text-foreground',
        settings.largeText && 'text-[110%]',
      )}
    >
      <Splash />
      <div className="mx-auto flex min-h-screen w-full max-w-[560px] flex-col">
        {!onSettingsPage && (
          <header className="flex items-center justify-between px-5 pt-6 pb-3">
            <div>
              <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                {t('welcome_back')}
              </p>
              <h1 className="text-lg font-semibold text-foreground">James Halloran</h1>
            </div>
            <div className="flex items-center gap-2">
              <Link
                to="/client-pwa/settings"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground hover:bg-secondary"
              >
                <SettingsIcon className="h-4 w-4" />
              </Link>
              <div className={cn('flex h-10 w-10 items-center justify-center rounded-full text-sm font-medium text-white', accent.bg)}>
                BA
              </div>
            </div>
          </header>
        )}

        <main className="flex-1 px-5 pb-32">
          <Outlet />
        </main>

        <nav className="fixed bottom-0 left-1/2 w-full max-w-[560px] -translate-x-1/2 border-t border-border bg-card/90 px-2 py-2 backdrop-blur-md">
          <div className="flex items-center justify-around">
            {navItems.map(({ to, icon: Icon, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  cn(
                    'flex flex-1 flex-col items-center gap-1 rounded-xl px-3 py-2 transition-colors',
                    isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon className={cn('h-6 w-6', isActive && 'stroke-[2.5]')} />
                    <span className={cn('text-xs', isActive && 'font-semibold')}>{label}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
}

export default function ClientPwaLayout() {
  return (
    <SettingsProvider>
      <ClientPwaShell />
    </SettingsProvider>
  );
}
